import React from 'react';
import PlatformImgae from '../Assets/Image/Platform.jpg';
import { MdArrowForwardIos } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

export const Platform = () => {
  const navigate = useNavigate();

  return (
    <section className='px-4 sm:px-10 md:px-20 bg-t-wh py-16'>
      <div className='mx-auto gap-8 max-w-[1440px] flex flex-col'>
        <div className='space-y-2'>
          <h3 className='text-b-mc '>PLATFORM</h3>
          <h2 className='text-2xl font-semibold'>What Can You Do?</h2>
        </div>
        <div className='gap-x-20 gap-y-10 w-full grid md:grid-cols-2'>
          <img src={PlatformImgae} alt='img' className=' col-span-1 w-full' />
          <div className='flex flex-col gap-12 col-span-1'>
            <div className='space-y-2'>
              <h3 className='font-semibold text-lg'>
                Perform Currency Exchange
              </h3>

              <p className='leading-loose'>
                Find trusted persons to enable you make legitimate
                multi-currency payments and possibly earn a commission
              </p>
            </div>
            <button
              className='text-p-wh justify-center disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 px-4 py-3 w-fit h-fit font-semibold disabled:bg-b-mct bg-b-mc rounded-md relative flex flex-row gap-4 items-center'
              onClick={() => navigate('/fxexchange')}
            >
              Currency Exchange
              <span className='rounded-md text-sm'>
                <MdArrowForwardIos />
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
